import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import userServiceApi from "../api/userServiceApi";

const useFormHandlerWorkExp = ({ micrositeId, eofOpportunityTitle }) => {
  const [loader, setLoader] = useState(false);

  const setNewToggledData = (headerData, response, setFinalData) => {
    const rowIndex = headerData.findIndex(
      (row) =>
        row.experienceOfWorkID === response?.data?.experienceOfWorkTitleId
    );
    const oppOutput = response?.data?.experienceOfWorkOpportunityOutput;
    const isVirtual = oppOutput?.opportunityType === "VIRTUAL";
    const key = isVirtual ? "virtual" : "faceToFace";
    const titleIndex = isVirtual ? 0 : 1;

    headerData[rowIndex][key] = {
      experienceOfWorkOppID:
        eofOpportunityTitle?.data?.[titleIndex]?.id || null,
      experienceOfWorkOppTitle:
        eofOpportunityTitle?.data?.[titleIndex]?.value || null,
      toggle: oppOutput?.toggle || false,
      description: oppOutput?.description || null,
      id: response?.data?.id || null,
      media: {
        mediaid: oppOutput?.media?.id || null,
        mediaType: oppOutput?.media?.mediaType || null,
        url: oppOutput?.media?.url || null,
      },
    };

    setFinalData([...headerData]);
  };

  const sendRequest = async ({
    method,
    data,
    id = null,
    onSuccess,
    onError,
  }) => {
    setLoader(true);
    try {
      const url =
        method === "put"
          ? userServiceApi.updateeof(micrositeId, id)
          : userServiceApi.geteof(micrositeId);

      const response = await axios[method](url, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
        },
      });

      // ✅ Check if request succeeded
      if (response?.status === 200 || response?.data?.success) {
        toast.success("Updated successfully");
      }

      if (onSuccess) onSuccess(response);
    } catch (error) {
      console.log("Error in sendRequest:", error);
      toast.error(error?.message || "Something went wrong");
      if (onError) onError(error);
    } finally {
      setLoader(false);
    }
  };


  const handleSubmit = ({ data, id, headerData, setFinalData }) => {
    const method = id ? "put" : "post";
    sendRequest({
      method,
      data,
      id,
      onSuccess: (response) =>
        setNewToggledData(headerData, response, setFinalData),
    });
  };

  return {
    loader,
    handleSubmit,
  };
};

export default useFormHandlerWorkExp;
